import React from 'react';
import { getCountries } from 'app/store/Countries/selectors';
import { useResource } from 'app/utils/hooks';
import { fetchCountriesEffect } from 'app/store/Countries/effects';
import { ContributionForm } from '../ContributionForm';

interface CreateContributionProps {
  onClose: () => void;
}

export const CreateContribution = ({ onClose }: CreateContributionProps) => {
  const [countries] = useResource(fetchCountriesEffect, getCountries);

  return countries ? (
    <ContributionForm countries={countries} onClose={onClose} />
  ) : null;
};
